import React from "react";
import { Container, Typography, Paper, Box } from "@mui/material";
import Footer from "./Footer";
import SeoHead from "../Components/SEO/SeoHead";
import { BASE_SITE_URL } from "../config";
import { useTranslation } from "react-i18next";

const renderTextBlocks = (text: string) => {
  return text.split("\\n\\n").map((block, blockIndex) => {
    const lines = block.split("\\n");
    return (
      <Typography key={blockIndex} variant="body1" paragraph>
        {lines.map((line, lineIndex) => (
          <React.Fragment key={`${blockIndex}-${lineIndex}`}>
            {line}
            {lineIndex < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </Typography>
    );
  });
};

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const introParagraphs = t("privacyPolicyPage.intro", { returnObjects: true }) as string[];
  const sections = t("privacyPolicyPage.sections", { returnObjects: true }) as {
    title: string;
    body: string;
  }[];

  const privacyStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: t("privacyPolicyPage.seoTitle"),
    url: `${BASE_SITE_URL}/PrivacyPolicy`,
    description: t("privacyPolicyPage.structuredDataDescription"),
  };
  return (
    <Box
      id="privacy-policy-page"
      key={`mainContentBoxDiv`}
      sx={{
        backgroundColor: "background.default",
        color: "text.primary",
        overflow: "hidden",
      }}
    >
      <SeoHead
        title={t("privacyPolicyPage.seoTitle")}
        description={t("privacyPolicyPage.seoDescription")}
        path="/PrivacyPolicy"
        keywords={["music tier list privacy", "privacy policy", "music ranking data", "user data protection"]}
        structuredData={privacyStructuredData}
      />
      <Container maxWidth="md" sx={{ height: "calc(100% - 125px)", marginTop: 4 }}>
        <Box sx={{ textAlign: "center", marginTop: 4, marginBottom: 1 }}>
          <Typography variant="h4" gutterBottom>
            {t("privacyPolicyPage.title")}
          </Typography>
          <Typography variant="h6" color="gray">
            <i>{t("privacyPolicyPage.updated")}</i>
          </Typography>
        </Box>

        <Paper
          sx={{
            padding: 3,
            height: "calc(100% - 125px)",
            overflowY: "scroll",
          }}
        >
          {Array.isArray(introParagraphs) && introParagraphs.map((paragraph, index) => (
            <Typography key={index} variant="body1" paragraph>
              {paragraph}
            </Typography>
          ))}

          {Array.isArray(sections) && sections.map((section, index) => (
            <Box key={index} sx={{ marginTop: index === 0 ? 3 : 2 }}>
              <Typography variant="h5" sx={{ marginBottom: 1 }}>
                {section.title}
              </Typography>
              {renderTextBlocks(section.body)}
            </Box>
          ))}
        </Paper>
      </Container>
      <Footer />
    </Box>
  );
};

export default PrivacyPolicy;
